// libraries.
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store';

// interfaces.
import type { MissingIntersection } from '../api-slices/auditIntersections.endpoints';

export interface AuditIntersectionsState {
  requested: boolean;
  selected: MissingIntersection | null;
}

export const initialState: AuditIntersectionsState = {
  requested: false,
  selected: null,
};

export const domainAuditIntersectionsSlice = createSlice({
  name: 'domainAuditIntersections',
  initialState,
  reducers: {
    setAuditIntersectionsRequested: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.requested = action.payload;
    },
    setSelectedMissingIntersection: (
      state,
      action: PayloadAction<MissingIntersection | null>
    ) => {
      state.selected = action.payload;
    },
  },
});

export const {
  setAuditIntersectionsRequested,
  setSelectedMissingIntersection,
} = domainAuditIntersectionsSlice.actions;

export default domainAuditIntersectionsSlice.reducer;

// selectors.
export const getAuditIntersectionsRequested = (state: RootState) =>
  state.domainAuditIntersections.requested;

export const getSelectedMissingIntersection = (state: RootState) =>
  state.domainAuditIntersections.selected;
